import { isWeb } from '@gluestack-ui/nativewind-utils/IsWeb';
import { Inbox as InboxIcon, MessageCircle, CheckCircle, PenLine } from 'lucide-react-native';

import { type TabRoute } from './types';

export const LOAD_MORE_SCROLL_THRESHOLD = isWeb ? 0.3 : 0.5;

export const TAB_ROUTES: TabRoute[] = [
  {
    key: 'all',
    title: 'All',
    count: 0,
    desktopTitle: 'All',
    index: 0,
    desktopIcon: InboxIcon,
  },
  {
    key: 'open',
    title: 'Open',
    count: 0,
    desktopTitle: 'Open',
    index: 1,
    desktopIcon: MessageCircle,
  },
  {
    key: 'closed',
    title: 'Closed',
    count: 0,
    desktopTitle: 'Closed',
    index: 2,
    desktopIcon: CheckCircle,
  },
  {
    key: 'drafts',
    title: 'Drafts',
    count: 0,
    desktopTitle: 'Drafts',
    index: 3,
    desktopIcon: PenLine,
  },
];
